import { isResponseError } from "./../utils/utils";
const axios = require("axios");

axios.defaults.withCredentials = true;
let sessionExpiredCallback = null;
let accessRestrictedCallback = null; //por si borran el usuario
let globalCsrfToken = null;

const isResp401 = (response) => {
  return (response && response.data && response.data.res === 401) || response.res === "401";
};

export const setSessionExpiredCallback = (cb) => {
  sessionExpiredCallback = cb;
};
export const setAccessRestrictedCallback = (cb) => {
  accessRestrictedCallback = cb;
};

export const getGlobalCsrToken = () => {
  return globalCsrfToken;
};

export const apiGet = (url, cancelSource, noCoors, noCache, blob) => {
  if (noCache) {
    url = `${url}?_=${new Date().getTime()}`;
  }
  const HTTP = axios.create({
    withCredentials: noCoors ? false : true,
  });
  return new Promise((resolve, reject) => {
    let options = {};
    if (blob) options.responseType = "blob";
    if (cancelSource) options.cancelToken = cancelSource.token;
    HTTP.get(url, options)
      .then((response) => {
        if (isResp401(response) && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          if (response.status >= 200 && response.status < 300 && !isResponseError(response)) {
            const csrfHeader = "x-csrf-token";
            let csrfToken = response.headers[csrfHeader];
            if (csrfToken == null) {
              csrfToken = response.data.CSRFToken;
            }
            if (csrfToken != null) {
              globalCsrfToken = csrfToken;
              axios.defaults.headers.post[csrfHeader] = csrfToken;
              axios.defaults.headers.delete[csrfHeader] = csrfToken;
              axios.defaults.headers.put[csrfHeader] = csrfToken;
              axios.defaults.headers.patch[csrfHeader] = csrfToken;
            }
            return resolve(response.data);
          } else {
            return reject(response);
          }
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};

export const apiPut = (url, id, obj, noCoors) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  let finalUrl = id ? `${url}/${id}` : url;
  return new Promise((resolve, reject) => {
    HTTP.put(finalUrl, obj)
      .then((response) => {
        if (isResp401(response) && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          if (response.status >= 200 && response.status < 300 && !isResponseError(response)) {
            return resolve(response.data);
          } else {
            return reject(response);
          }
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};
export const apiPatch = (url, id, obj, noCoors) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  let finalUrl = id ? `${url}/${id}` : url;
  return new Promise((resolve, reject) => {
    HTTP.patch(finalUrl, obj)
      .then((response) => {
        if (isResp401(response) && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          if (response.status >= 200 && response.status < 300 && !isResponseError(response)) {
            return resolve(response.data);
          } else {
            return reject(response);
          }
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};

export const apiPost = (url, obj, noCoors, cancelSource, blob) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  return new Promise((resolve, reject) => {
    let options = {};
    if (blob) options.responseType = "blob";
    if (cancelSource) options.cancelToken = cancelSource.token;
    HTTP.post(`${url}`, obj, options)
      .then((response) => {
        if (isResp401(response) && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          if (response.status >= 200 && response.status < 300 && !isResponseError(response)) {
            return resolve(response.data);
          } else {
            return reject(response);
          }
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};

export const apiDelete = (url, id, noCoors) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  return new Promise((resolve, reject) => {
    let finalUrl = id ? `${url}/${id}` : url;
    HTTP.delete(finalUrl)
      .then((response) => {
        if (response.status >= 200 && response.status < 300 && !isResponseError(response)) {
          return resolve(response.data);
        } else {
          return reject(response);
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};

export const apiUploadFile = (url, file, extraFormData, noCoors, cancelSource, fileName) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  return new Promise((resolve, reject) => {
    var formData = new FormData();
    if (fileName) {
      formData.append("file", file, fileName);
    } else {
      formData.append("file", file);
    }

    if (extraFormData) {
      extraFormData.forEach((e) => {
        formData.append(e.name, e.value);
      });
    }
    let options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    if (cancelSource) options.cancelToken = cancelSource.token;
    HTTP.post(`${url}`, formData, options)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return resolve(response.data);
        } else {
          return reject(response);
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};
export const apiUploadMultiFiles = (url, files, extraFormData, noCoors, cancelSource) => {
  const HTTP = axios.create({
    // withCredentials: noCoors ? false:true
  });
  return new Promise((resolve, reject) => {
    var formData = new FormData();
    files.forEach((file, index) => {
      const key = `data[${index}]`;
      Object.entries(file).forEach((ob) => {
        if (ob[0] === "file") {
          formData.append(`${key}.${ob[0]}`, ob[1].blob, ob[1].name);
        } else {
          formData.append(`${key}.${ob[0]}`, ob[1]);
        }
      });
    });

    if (extraFormData) {
      extraFormData.forEach((e) => {
        formData.append(e.name, e.value);
      });
    }
    let options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    if (cancelSource) options.cancelToken = cancelSource.token;
    HTTP.post(`${url}`, formData, options)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return resolve(response.data);
        } else {
          return reject(response);
        }
      })
      .catch((e) => {
        if (e.response && e.response.status === 401 && sessionExpiredCallback) {
          sessionExpiredCallback();
          // reject(null);
        } else {
          reject(e);
        }
      });
  });
};

export const sessionExpired = () => {
  if (sessionExpiredCallback) {
    sessionExpiredCallback();
  }
};
export const accessRestricted = (exception) => {
  if (accessRestrictedCallback) {
    accessRestrictedCallback(exception);
  }
};
